module.exports = __webpack_public_path__ + "static/media/leclerc8.7a24b134.jpg";